// import React from "react";

// const vehicles = [
//   {
//     id: 1,
//     name: "Hyundai Aura",
//     image: "images/fleets/Aura.jpg",
//     desc: "Comfortable 4-seater sedan for city rides and airport transfers.",
//   },
//   {
//     id: 2,
//     name: "Maruti Dzire",
//     image: "images/fleets/Dzire.jpg",
//     desc: "Budget-friendly sedan with smooth performance for daily travel.",
//   },
//   {
//     id: 3,
//     name: "Ertiga",
//     image: "images/fleets/Ertiga.jpg",
//     desc: "Spacious 6-seater ideal for family trips and outstation travel.",
//   },
//   {
//     id: 4,
//     name: "Kia Carens",
//     image: "images/fleets/Kia.jpg",
//     desc: "Premium 6-seater MPV with extra comfort and space.",
//   },
//   // {
//   //   id: 5,
//   //   name: "Innova",
//   //   image: "images/fleets/Innova.jpg",
//   //   desc: "Reliable SUV for long-distance and comfortable rides.",
//   // },
//   {
//     id: 6,
//     name: "Innova Crysta",
//     image: "images/fleets/Innova-Crysta.jpg",
//     desc: "Luxury 7-seater SUV for premium travel experience.",
//   },
//     {
//     id: 9,
//     name: "Mini Bus",
//     image: "images/fleets/Bus.jpg",
//     desc: "Large-capacity mini bus ideal for weddings and tours.",
//   },
//   {
//     id: 7,
//     name: "Tempo Traveller",
//     image: "images/fleets/Tempo-traveler.jpg",
//     desc: "Perfect for group travel with 12–14 passengers.",
//   },
//   {
//     id: 8,
//     name: "Urbania",
//     image: "images/fleets/urbania.jpg",
//     desc: "Modern luxury traveller for long-distance group tours.",
//   },
//   {
//     id: 9,
//     name: "Bus",
//     image: "images/fleets/Bus.jpg",
//     desc: "Large capacity bus ideal for weddings and tours.",
//   },
// ];

// const OurFleets = () => {
//   return (
//     <>
//       <div className="breadcrumb-bar">
//         <div className="container">
//           <div className="row align-items-center text-center">
//             <div className="col-md-12 col-12">
//               <h2 className="breadcrumb-title text-white">Our Fleets</h2>
//             </div>
//           </div>
//         </div>
//       </div>
    
//     <div className="section-full py-3 fleet-wrap">
//       <div className="container">

//         {/* Title */}
//         <div className="text-center mb-5">
//           <h2 style={{ color: "#5a2d0c" }}>Shivai Travels Fleet</h2>
//           <p style={{ color: "#8b5e3c" }}>
//             Comfortable & reliable vehicles for every journey
//           </p>
//         </div>

//         {/* Grid */}
//         <div className="row">

//           {vehicles.map((item) => (
//             <div key={item.id} className="col-lg-4 col-md-4 col-sm-6 mb-4">

//               <div className="fleet-card">

//                 <div className="fleet-img">
//                   <img src={item.image} alt={item.name} />
//                 </div>

//                 <div className="fleet-content">
//                   <h4>{item.name}</h4>
//                   <p>{item.desc}</p>
//                 </div>

//               </div>

//             </div>
//           ))}

//         </div>

//       </div>

//       {/* Styling */}
//       <style jsx>{`
//         .fleet-wrap {
//           background: linear-gradient(135deg, #fff7ed, #fef3e2);
//         }

//         .fleet-card {
//           background: #fff;
//           border-radius: 12px;
//           overflow: hidden;
//           border: 1px solid #f3d6b3;
//           box-shadow: 0 6px 18px rgba(90, 45, 12, 0.12);
//           transition: 0.3s;
//           height: 100%;
//         }

//         .fleet-card:hover {
//           transform: translateY(-6px);
//         }

//         .fleet-img img {
//           width: 100%;
//         //   height: 200px;
//           object-fit: cover;
//         }

//         .fleet-content {
//           padding: 15px;
//           text-align: center;
//         }

//         .fleet-content h4 {
//           color: #5a2d0c;
//           margin-bottom: 8px;
//         }

//         .fleet-content p {
//           color: #8b5e3c;
//           font-size: 14px;
//           margin: 0;
//         }
//       `}</style>
//     </div>
//     </>
//   );
// };

// export default OurFleets;








import React from "react";

const vehicles = [
  {
    id: 1,
    name: "Hyundai Aura",
    image: "images/fleets/Aura.jpg",
    desc: "Comfortable 4-seater sedan for city rides and airport transfers.",
    seats: "4+1",
    luggage: "2 Bags",
    type: "Sedan",
    popular: "Airport Transfer",
  },
  {
    id: 2,
    name: "Maruti Dzire",
    image: "images/fleets/Dzire.jpg",
    desc: "Budget-friendly sedan with smooth performance for daily travel.",
    seats: "4+1",
    luggage: "2 Bags",
    type: "Sedan",
    popular: "Local Travel",
  },
  {
    id: 3,
    name: "Ertiga",
    image: "images/fleets/Ertiga.jpg",
    desc: "Spacious 6-seater ideal for family trips and outstation travel.",
    seats: "6+1",
    luggage: "3 Bags",
    type: "MPV",
    popular: "Family Trip",
  },
  {
    id: 4,
    name: "Kia Carens",
    image: "images/fleets/Kia.jpg",
    desc: "Premium 6-seater MPV with extra comfort and space.",
    seats: "6+1",
    luggage: "3 Bags",
    type: "MPV",
    popular: "Premium Travel",
  },
  {
    id: 6,
    name: "Innova Crysta",
    image: "images/fleets/Innova-Crysta.jpg",
    desc: "Luxury 7-seater SUV for premium travel experience.",
    seats: "7+1",
    luggage: "4 Bags",
    type: "SUV",
    popular: "Outstation",
  },
  {
    id: 7,
    name: "Tempo Traveller",
    image: "images/fleets/Tempo-traveler.jpg",
    desc: "Perfect for group travel with 12–14 passengers.",
    seats: "12–14",
    luggage: "8 Bags",
    type: "Traveller",
    popular: "Group Tour",
  },
  {
    id: 8,
    name: "Urbania",
    image: "images/fleets/urbania.jpg",
    desc: "Modern luxury traveller for long-distance group tours.",
    seats: "12–17",
    luggage: "10 Bags",
    type: "Luxury Traveller",
    popular: "Luxury Group Travel",
  },
  {
    id: 9,
    name: "Mini Bus",
    image: "images/fleets/Bus.jpg",
    desc: "Large-capacity mini bus ideal for weddings and tours.",
    seats: "20–26",
    luggage: "15 Bags",
    type: "Mini Bus",
    popular: "Wedding & Tours",
  },
];

const OurFleets = () => {
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white">Our Fleets</h2>
            </div>
          </div>
        </div>
      </div>

      {/* Fleet Section */}
      <div className="section-full py-3 fleet-wrap">
        <div className="container">

          {/* Title */}
          <div className="text-center mb-5">
            <h2 style={{ color: "#5a2d0c" }}>Shivai Travels Fleet</h2>
            <p style={{ color: "#8b5e3c" }}>
              Comfortable & reliable vehicles for every journey
            </p>
          </div>

          {/* Grid */}
          <div className="row">
            {vehicles.map((item) => (
              <div key={item.id} className="col-lg-4 col-md-6 col-sm-6 mb-4">
                <div className="fleet-card">

                  <div className="fleet-img">
                    <img src={item.image} alt={item.name} />
                  </div>

                  <div className="fleet-content">
                    <h4>{item.name}</h4>

                    <div className="fleet-features">
                      <span>
                        <i className="fa fa-users"></i> {item.seats}
                      </span>
                      <span>
                        <i className="fa fa-suitcase"></i> {item.luggage}
                      </span>
                    </div>

                    <div className="fleet-features">
                      <span>
                        <i className="fa fa-car"></i> {item.type}
                      </span>
                      <span>
                        <i className="fa fa-star"></i> {item.popular}
                      </span>
                    </div>

                    <p>{item.desc}</p>

                  
                  </div>

                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Styles */}
        <style jsx>{`
          .fleet-wrap {
            background: linear-gradient(135deg, #fff7ed, #fef3e2);
          }

          .fleet-card {
            background: #fff;
            border-radius: 12px;
            overflow: hidden;
            border: 1px solid #f3d6b3;
            box-shadow: 0 6px 18px rgba(90, 45, 12, 0.12);
            transition: 0.3s;
            height: 100%;
          }

          .fleet-card:hover {
            transform: translateY(-6px);
          }

          .fleet-img img {
            width: 100%;
            object-fit: cover;
          }

          .fleet-content {
            padding: 20px;
            text-align: center;
          }

          .fleet-content h4 {
            color: #5a2d0c;
            font-weight: 700;
            margin-bottom: 15px;
          }

          .fleet-features {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
            font-size: 14px;
          }

          .fleet-features span {
            background: #fff7ed;
            padding: 8px 10px;
            border-radius: 20px;
            color: #5a2d0c;
            font-weight: 500;
          }

          .fleet-features i {
            color: #ff7a00;
            margin-right: 5px;
          }

          .fleet-content p {
            margin-top: 12px;
            color: #666;
            font-size: 14px;
            min-height: 50px;
          }

          .fleet-btn {
            background: #ff7a00;
            color: #fff;
            border: none;
            padding: 10px 22px;
            border-radius: 30px;
            font-weight: 600;
            transition: 0.3s;
            margin-top: 10px;
            cursor: pointer;
          }

          .fleet-btn:hover {
            background: #5a2d0c;
          }
        `}</style>
      </div>
    </>
  );
};

export default OurFleets;